export type TranslationStrings = {
  readonly [property: string]: TranslationStrings | string;
};

const flattenInto = (
  source: TranslationStrings,
  ancestors: readonly string[],
  output: Record<string, string>,
): void => {
  Object.entries(source).forEach(([key, value]) => {
    const path = [...ancestors, String(key)];

    if (typeof value === "string") {
      output[path.join(".")] = value;
      return;
    }

    flattenInto(value, path, output);
  });
};

export const flattenTranslationStrings = (
  source: TranslationStrings,
): Record<string, string> => {
  const output: Record<string, string> = {};
  flattenInto(source, [], output);
  return output;
};
